var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("Menu.Correspondences")))]),
    _vm._v(" "),
    _vm.correspondences
      ? _c(
          "div",
          { staticClass: "table-responsive sortable" },
          [
            _c("filter-input-row", {
              attrs: {
                title: "Correspondences.Filter.Title",
                id: "correspondencesfilter",
                filterFunction: _vm.filter,
                results: _vm.filteredCorrespondences.length,
                resultsAriaText: "Correspondences.Filter.ResultsAriaText"
              },
              model: {
                value: _vm.filterValue,
                callback: function($$v) {
                  _vm.filterValue = $$v
                },
                expression: "filterValue"
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "sr-only",
                attrs: { "aria-live": "assertive", "aria-atomic": "true" }
              },
              [_vm._v("\n      " + _vm._s(_vm.srSortedBy) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table tablerow correspondences-table sortable" },
              [
                _c("caption", [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("Menu.Correspondences")) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pull-right sort-instructions" }, [
                    _vm._v(_vm._s(_vm.$t("Sort.Instructions")))
                  ])
                ]),
                _vm._v(" "),
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "w-10",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "correspondenceDeadline",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayCorrespondences = _vm.sort(
                                  "correspondenceDeadline",
                                  _vm.filteredCorrespondences
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Deadline",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "correspondenceDeadline",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-15",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "correspondenceTarget",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayCorrespondences = _vm.sort(
                                  "correspondenceTarget",
                                  _vm.filteredCorrespondences
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Correspondence.AidTarget",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "correspondenceTarget",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "w-15" }, [
                      _c("span", { staticClass: "unsortable bold" }, [
                        _vm._v(_vm._s(_vm.$t("Subject")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-15",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "correspondenceHeader",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayCorrespondences = _vm.sort(
                                  "correspondenceHeader",
                                  _vm.filteredCorrespondences
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Correspondence.Header",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "correspondenceHeader",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-25",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "correspondenceMessage",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayCorrespondences = _vm.sort(
                                  "correspondenceMessage",
                                  _vm.filteredCorrespondences
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Correspondence.Message",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "correspondenceMessage",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-10",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "correspondenceState",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayCorrespondences = _vm.sort(
                                  "correspondenceState",
                                  _vm.filteredCorrespondences
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "State",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "correspondenceState",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "w-10" }, [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.displayCorrespondences, function(item, index) {
                  return _vm.correspondences.length > 0
                    ? _c("tbody", { key: index }, [
                        _c(
                          "tr",
                          {
                            class: [
                              _vm.showPastDeadline(item) ? "past-deadline" : "",
                              "border-0"
                            ]
                          },
                          [
                            item.latestMessage.deadline
                              ? _c("td", [
                                  _c("div", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            item.latestMessage.deadline
                                          )
                                        )
                                      )
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.showPastDeadline(item)
                                      ? _c(
                                          "span",
                                          { staticClass: "past-deadline" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("toUpperCase")(
                                                  _vm.$t("PastDeadline")
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _vm._m(0, true)
                                ]),
                            _vm._v(" "),
                            item.aidTargetIdentifier || item.aidtargetNumber
                              ? _c("td", [
                                  item.aidTargetIdentifier
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title:
                                              item.aidTargetIdentifier.length >
                                              80
                                                ? item.aidTargetIdentifier
                                                : ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("truncate")(
                                                item.aidTargetIdentifier,
                                                80
                                              )
                                            ) + " "
                                          ),
                                          item.aidtargetNumber
                                            ? _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      item.aidtargetNumber
                                                    ) +
                                                    ")"
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(item.aidtargetNumber))
                                      ])
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _vm._m(1, true)
                                ]),
                            _vm._v(" "),
                            _vm.getDisplaySubject(
                              item.linkedEntityName,
                              item.linkedEntitySubType
                            )
                              ? _c("td", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getDisplaySubject(
                                          item.linkedEntityName,
                                          item.linkedEntitySubType
                                        )
                                      )
                                    )
                                  ])
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _c("span", [_vm._v("-")])
                                ]),
                            _vm._v(" "),
                            item.firstMessage.header
                              ? _c("td", [
                                  _c("span", [
                                    _vm._v(_vm._s(item.firstMessage.header))
                                  ])
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _c("span", [_vm._v("-")])
                                ]),
                            _vm._v(" "),
                            item.latestMessage
                              ? _c("td", [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        title:
                                          item.latestMessage.message &&
                                          item.latestMessage.message.length >
                                            100
                                            ? item.latestMessage.message
                                            : ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            item.latestMessage.message,
                                            100
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _c("span", [_vm._v("-")])
                                ]),
                            _vm._v(" "),
                            _vm.getDisplayState(item.state)
                              ? _c("td", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getDisplayState(item.state))
                                    )
                                  ])
                                ])
                              : _c("td", { staticClass: "centered" }, [
                                  _c("span", [_vm._v("-")])
                                ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "centered" }, [
                              _c(
                                "span",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      class: _vm.getButtonStyle(),
                                      attrs: {
                                        to: {
                                          name: "correspondence",
                                          params: { id: item.referenceId }
                                        },
                                        tag: "button",
                                        "aria-label":
                                          _vm.$t(_vm.getButtonText(item)) +
                                          " " +
                                          _vm.getDisplaySubject(
                                            item.linkedEntityName
                                          ) +
                                          " " +
                                          item.header
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(_vm.getButtonText(item))
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("-")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("-")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }